export const collectionOrder = [
  'Bryant',
  'Bryant Petite',
  'Bryant Slipcovered',
  'Holt',
  'Holt Petite',
  'Sebastian',
  'Maurice',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];

export const collectionQuickLinks = [
  'Bryant',
  'Holt',
  'Sebastian',
  'Maurice',
  'Haine',
  'Daya',
  'Logan',
  'Antony',
  'Diane',
];
